import { EventEmitter, Output, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class ClassesUtil {

    constructor() { }

    addClass(element: Element, className: string): void {
        if (this.hasClass(element, className)) {
            return;
        }

        if (element.className.length) {
            element.className += ' ' + className;
        } else {
            element.className = className;
        }
    }

    removeClass(element: Element, className: string): void {
        let classNames = element.className.split(' ');
        let newClass = '';

        for (let i = 0; i < classNames.length; i++) {
            if (className !== classNames[i]) {
                if (newClass.length) {
                    newClass += ' ' + classNames[i];
                } else {
                    newClass = classNames[i];
                }
            }
        }
        element.className = newClass;
    }

    hasClass(element: Element, className: string): boolean {
        let classNames = element.className.split(' ');
        for (let i = 0; i < classNames.length; i++) {
            if (className === classNames[i]) {
                return true;
            }
        }
        return false;
    }
}
